"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    filterDropdown: {
        someSelected: '{{label}}s selected',
        customSomeSelected: '{{label}} selected',
        allSelected: 'All {{label}}s',
    },
};
